module.exports = "/lucky-balls/img/combos/201.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/combos/201.png
// module id = 999
// module chunks = 0